var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"no-gutters":"","align":"center","justify":"space-around"}},[_c('v-col',[_c('v-btn',{attrs:{"disabled":_vm.disableButton,"color":"#7C65C2","small":"","fab":""},on:{"click":_vm.downloadDocument}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(" mdi-file-document ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }